/**
 * Host-only in-memory template map. Public-share bake passes `templateDocument`
 * on the binding context, so membership refs do not need the live registry.
 */
export const TemplateRuntimeRegistry = {
  getTemplate(_id?: string): undefined {
    return undefined;
  },
  register(_tpl?: unknown): void {},
  get(_id?: string): undefined {
    return undefined;
  },
};
